import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProcessingStatusSlice } from '../app-state';
import { PipelineRunDocument } from '../../../model/documents/pipeline-run-document.model';
import { selectSelectedPipelineRunForPipeline } from '../pipeline-run/pipeline-run.selectors';

export const selectProcessingStatusSlice = createFeatureSelector<ProcessingStatusSlice>('processingStatusSlice');

export const selectPipelineRunProcessingStatus = (pipelineRunId: number) =>
  createSelector(selectProcessingStatusSlice, (processingStatusSlice) => {
    return processingStatusSlice.pipelineRunProcessingStatus[pipelineRunId];
  });

export const selectPipelineRunProcessingStatusByPipelineId = (pipelineId: string) =>
  createSelector(
    selectSelectedPipelineRunForPipeline(pipelineId),
    selectProcessingStatusSlice,
    (selectedPipelineRunId, processingStatusSlice) => {
      return processingStatusSlice.pipelineRunProcessingStatus[selectedPipelineRunId];
    },
  );

export const selectPipelineRunUnprocessedFilesRaw = (pipelineRunId: number) =>
  createSelector(selectPipelineRunProcessingStatus(pipelineRunId), (pipelineRunProcessingStatus) => {
    return pipelineRunProcessingStatus?.unprocessedFiles;
  });

export const selectHasUnprocessedFiles = (pipelineRunId: number) =>
  createSelector(selectPipelineRunUnprocessedFilesRaw(pipelineRunId), (unprocessedFiles) => {
    return unprocessedFiles?.length > 0;
  });

export const selectPipelineRunUnprocessedFilesMapped = (pipelineRunId: number) =>
  createSelector(selectPipelineRunUnprocessedFilesRaw(pipelineRunId), (unprocessedFilesRaw: string[]) => {
    return unprocessedFilesRaw.map((file) => PipelineRunDocument.fromUnprocessedFile(file));
  });
